/* eslint no-underscore-dangle: "off" */

export class WebSocketConnection {
  constructor(url) {
    this._url = url;
    this._abortController = null;
  }

  addMessageHandler(handler) {
    this._messageHandler = handler;
  }

  async send(message) {
    // 新しいAbortControllerを作成
    this._abortController = new AbortController();
    const { signal } = this._abortController;

    if (!this._ws) {
      this._connect();
    }

    await this._waitForConnection(signal);

    this._ws.send(JSON.stringify(message));
  }

  close() {
    // 進行中の送信をキャンセル
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }

    // WebSocket接続をクローズ
    if (this._ws) {
      this._ws.close();
      this._ws = null;
    }
  }

  async _waitForConnection(signal) {
    try {
      await this._wsOpenPromise;

      // 接続完了後、送信直前にもAbortチェック
      if (signal.aborted) {
        throw this._createAbortError();
      }
    } catch (error) {
      // Abortされた場合はAbortErrorをスロー
      if (signal.aborted) {
        throw this._createAbortError();
      }
      // その他のエラーは再スロー
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  _createAbortError() {
    const error = new Error('Send aborted');
    error.name = 'AbortError';
    return error;
  }

  _connect() {
    let resolve;
    let reject;
    this._wsOpenPromise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    this._ws = new WebSocket(this._url);
    this._ws.addEventListener('open', resolve);
    this._ws.addEventListener('error', (event) => {
      reject(event);
      this._ws = null;
    });
    this._ws.addEventListener('close', (event) => {
      reject(event);
      this._ws = null;
    });

    this._ws.addEventListener('message', (event) => {
      if (this._messageHandler) {
        this._messageHandler(event);
      }
    });
  }
}
